'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgeDescription = exports.getPlacementLabel = exports.getGenderLabel = exports.getAwardType = exports.getEventLabel = undefined;

var _ifeisIsomorphic = require('ifeis-isomorphic');

var getEventLabel = exports.getEventLabel = function getEventLabel(event) {
  switch (event.get('type')) {
    case 'G':
      return 'Grades';
    case 'S':
      return 'Specials';
    case 'C':
      return 'Champs';
    case 'F':
      return 'Figures';
    default:
      return 'Unknown';
  }
};

var getAwardType = exports.getAwardType = function getAwardType(event) {
  var awardType = event.get('awardType');
  return awardType || '';
};

var getGenderLabel = exports.getGenderLabel = function getGenderLabel(event) {
  switch (event.get('gender')) {
    case 'M':
      return 'Male';
    case 'F':
      return 'Female';
    default:
      return '';
  }
};

var getPlacementLabel = exports.getPlacementLabel = function getPlacementLabel(ev) {
  if (ev.get('place_pct')) {
    return ev.get('place_pct') + '%';
  } else if (ev.get('place_cnt')) {
    return '' + ev.get('place_cnt');
  } else if (ev.get('nafc_or_place_pct')) {
    return ev.get('nafc_or_place_pct') + '% or NAFC';
  } else if (ev.get('nafc_or_place_cnt')) {
    return ev.get('nafc_or_place_cnt') + ' or NAFC';
  } else {
    return '';
  }
};

var getAgeDescription = exports.getAgeDescription = function getAgeDescription(ev) {
  if (ev.get('age_min') && !ev.get('age_max')) {
    return '>' + ev.get('age_min');
  } else if (!ev.get('age_min') && ev.get('age_max')) {
    return '<' + ev.get('age_max');
  } else if (ev.get('age_min') === ev.get('age_max')) {
    return '=' + ev.get('age_min');
  } else {
    return ev.get('age_min') + ' - ' + ev.get('age_max');
  }
};

exports.default = angular.module('ifeis.events', []).value('AGE_STRING_REGEXP', /^([uo])?(\d+)&?(o|u)?$/i).factory('fEventService', function ($http, AGE_STRING_REGEXP) {
  var feis_prefix = IFEIS_API_URI + '/api/feiseanna';

  function serializeEvent(ev) {
    var event = angular.copy(ev);
    // event.age = event.age.str;

    return event;
  }

  function deserializeEvent(ev) {
    var event = angular.copy(ev);
    event.$name = (0, _ifeisIsomorphic.getDescription)(ev);
    return event;
  }

  function Events(id) {
    this.prefix = feis_prefix + '/' + id + '/events';
  }

  Events.prototype.create = function (event) {
    return $http.post(this.prefix, serializeEvent(event)).then(function (ev) {
      return deserializeEvent(ev);
    });
  };

  Events.prototype.all = function (filters) {
    return $http.get(this.prefix, { params: filters }).then(function (ev) {
      var events = angular.copy(ev).map(deserializeEvent);

      return events;
    });
  };

  Events.prototype.one = function (id, filters) {
    return $http.get(this.prefix + '/' + id, { params: filters }).then(deserializeEvent);
  };

  Events.prototype.participants = function (id) {
    return $http.get(this.prefix + '/' + id + '/participants');
  };

  Events.prototype.adjudicators = function (id) {
    return $http.get(this.prefix + '/' + id + '/adjudicators');
  };

  Events.prototype.update = function (id, event) {
    return $http.put(this.prefix + '/' + id, serializeEvent(event)).then(deserializeEvent);
  };

  Events.prototype.delete = function (id) {
    return $http.delete(this.prefix + '/' + id);
  };

  Events.prototype.split = function (id, props1, persons1, props2, persons2) {
    return $http.post(this.prefix + '/' + id + '/split', {
      persons1: persons1, persons2: persons2,
      props1: serializeEvent(props1),
      props2: serializeEvent(props2)
    }).then(function (ev) {
      var events = angular.copy(ev).map(deserializeEvent);

      return events;
    });
  };

  Events.prototype.merge = function (a, b, props) {
    return $http.post(this.prefix + '/' + a + '/merge/' + b, serializeEvent(props)).then(deserializeEvent);
  };

  Events.prototype.checkin = function (eid, pid) {
    return $http.post(this.prefix + '/' + eid + '/participants/' + pid + '/checkin');
  };

  Events.prototype.checkout = function (eid, pid) {
    return $http.post(this.prefix + '/' + eid + '/participants/' + pid + '/checkout');
  };

  Events.prototype.updateRegistration = function (eid, pid, reg) {
    return $http.put(this.prefix + '/' + eid + '/participants/' + pid, reg);
  };

  Events.prototype.open = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/open');
  };

  Events.prototype.close = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/close');
  };

  Events.prototype.orderParticipants = function (eid, order) {
    return $http.post(this.prefix + '/' + eid + '/order-participants', order);
  };

  Events.prototype.checkinToTabs = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/checkin');
  };

  Events.prototype.sendToQa = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/send-to-qa');
  };

  Events.prototype.reset = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/reset');
  };

  Events.prototype.sendToResults = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/send-to-results');
  };

  Events.prototype.getScores = function (eid, aid) {
    return $http.get(this.prefix + '/' + eid + '/adjudicators/' + aid + '/scores');
  };

  Events.prototype.createScore = function (eid, aid, pid, score) {
    return $http.post(this.prefix + '/' + eid + '/scores/' + aid + '/' + pid, score);
  };

  Events.prototype.deleteScoresByAdjudicator = function (eid, aid) {
    return $http.delete(this.prefix + '/' + eid + '/scores/' + aid);
  };

  Events.prototype.deleteScore = function (eid, aid, sid) {
    return $http.delete(this.prefix + '/' + eid + '/scores/' + aid + '/' + sid);
  };

  Events.prototype.updateScore = function (eid, aid, score) {
    return $http.put(this.prefix + '/' + eid + '/scores/' + aid + '/' + score.id, score);
  };

  Events.prototype.placements = function (eid) {
    return $http.get(this.prefix + '/' + eid + '/placements');
  };

  Events.prototype.cachePlacements = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/placements/cache');
  };

  Events.prototype.collectAward = function (eid, pid) {
    return $http.post(this.prefix + '/' + eid + '/placements/' + pid + '/collect-award');
  };

  Events.prototype.returnAward = function (eid, pid) {
    return $http.post(this.prefix + '/' + eid + '/placements/' + pid + '/return-award');
  };

  Events.prototype.setPlacementsPrinted = function (eid, pid, version_id) {
    return $http.post(this.prefix + '/' + eid + '/placements-printed', { version_id: version_id });
  };

  Events.prototype.setRecallsPrinted = function (eid, pid, version_id) {
    return $http.post(this.prefix + '/' + eid + '/recalls-printed', { version_id: version_id });
  };

  Events.prototype.setAnnounced = function (eid) {
    return $http.post(this.prefix + '/' + eid + '/set-announced');
  };

  var statuses = [{
    label: 'Pending',
    status: 'PND',
    desc: 'This competition exists, but nothing has happened with it yet.'
  }, {
    label: 'Checking In',
    status: 'CI',
    desc: 'The stage steward has opened this event to allow participants to check in.'
  }, {
    label: 'Adjudication',
    status: 'ADJ',
    desc: 'Check-in for this event has been closed, and it is now in the hands of the adjudicators.'
  }, {
    label: 'Tabulations',
    status: 'TABS',
    desc: 'This event has been scored by adjudicators and the tabulations team is doing data entry.'
  }, {
    label: 'Quality Assurance',
    status: 'QA',
    desc: 'Scores for this event are in, but the tabulations team is currently ensuring accuracy.'
  }, {
    label: 'To Announce',
    status: 'RCL',
    desc: 'Placements should be announced before releasing results.'
  }, {
    label: 'Results, Comments Pending',
    status: 'COMMENTS-UNRELEASED',
    desc: 'Events are released to public but comments are not released.'
  }, {
    label: 'Results, Comments Released',
    status: 'RES',
    desc: 'Scores for this competition are ready, but may or may not be public.'
  }];

  /**
   * Return an age object from a string age.
   */
  function ageFromString(str) {
    var matches = str.match(AGE_STRING_REGEXP);
    var age = {
      str: str
    };

    if (matches) {
      age.number = parseInt(matches[2], 10);

      age.exclusive = matches[1] ? 1 : 0;
      age.inclusive = matches[3] ? 1 : 0;

      if (matches[1] && matches[1].toLowerCase() === 'u') {
        age.direction = -1;
      } else if (matches[1] && matches[1].toLowerCase() === 'o') {
        age.direction = 1;
      } else if (matches[3] && matches[3].toLowerCase() === 'u') {
        age.direction = -1;
      } else if (matches[3] && matches[3].toLowerCase() === 'o') {
        age.direction = 1;
      } else {
        age.direction = 0;
      }
    }

    return age;
  }

  /**
   * Exported API
   */

  return {
    for: function _for(id) {
      return new Events(id);
    },
    ageFromString: ageFromString,
    serializeEvent: serializeEvent,
    deserializeEvent: deserializeEvent,
    statuses: statuses
  };
}).filter('sortByAgeRange', function () {
  return function (input) {
    return input.sort(function (a, b) {
      // If the start of the ranges are different, we sort based solely on that.
      if (a.number < b.number) {
        return -1;
      } else if (a.number > b.number) {
        return 1;
      } else {
        // U8 before 8&O
        if (a.inclusive !== 1 && b.inclusive === 1 && a.direction === -1 && b.direction === 1) {
          return -1;
        } else if (b.inclusive !== 1 && a.inclusive === 1 && b.direction === -1 && a.direction === 1) {
          return 1;

          // U8 before O8
        } else if (a.inclusive !== 1 && b.inclusive !== 1 && a.direction === -1 && b.direction === 1) {
          return -1;
        } else if (b.inclusive !== 1 && a.inclusive !== 1 && b.direction === -1 && a.direction === 1) {
          return 1;

          // 8&U before O8
        } else if (a.inclusive === 1 && b.inclusive !== 1 && a.direction === -1 && b.direction === 1) {
          return -1;
        } else if (b.inclusive === 1 && a.inclusive !== 1 && b.direction === -1 && a.direction === 1) {
          return -1;

          // For all non-logical combinations, we are not guaranteeing any particular order.
          // e.g. identical or overlapping values (8&O vs 8&U).
        } else {
          return 0;
        }
      }
    });
  };
}).directive('fAgeRange', function (AGE_STRING_REGEXP) {
  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.ageRange = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          return true;
        }

        if (AGE_STRING_REGEXP.test(viewValue)) {
          return true;
        }

        return false;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./events/index.js
// module id = 17
// module chunks = 0